export const getDisplayName = <P extends object>(WrappedComponent: React.ComponentType<P>): string => {
	const name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	const result = name.split('(');

	if (!Array.isArray(result) || result.length < 2) {
		return name;
	}
	return `-> ${result[result.length - 1].replace(/-> /g, '').replace(/\)/g, '')}`;
};
